import clsx from 'clsx';
import classes from './ContentButton.module.scss';

export type ButtonProps = {
  className?: string;
  children: React.ReactNode;
  onClick: () => void;
  href?: never;
  target?: never;
};

export type LinkProps = {
  className?: string;
  children: React.ReactNode;
  href: string;
  target?: string;
  onClick?: never;
};

export type Props = ButtonProps | LinkProps;

const ContentButton = ({ className, children, ...props }: Props) => {
  const Root = 'href' in props ? 'a' : 'button';

  return (
    <Root className={clsx(className, classes.root)} {...props}>
      <div className={classes.content}>{children}</div>
    </Root>
  );
};

export default ContentButton;
